import { htmlE } from "/WebInterface/new-ui/assets/js/utils/te.js";
import { mediaTypes } from "/WebInterface/new-ui/assets/js/constants.js";

const slideShowTemplate = htmlE`
  <span class="quick-view-pageTotal text-base"></span>
  <div class="quick-view-close">
    <i class="icon-remove"></i>
  </div>
  <div class="quick-view-player-section">
    </div>
  </div>
    <div class="quick-view-footer">
      <p class="name-bar text-base"></p>
      <div class="control-bar info-bar"></div>
    </div>
  </div>
`;

const controlBarTemplate = htmlE`
  ${({ canShowQuickShareButtonInQuickPreview }) => {
    if (canShowQuickShareButtonInQuickPreview) {
      return `
            <button data-tooltip="Share" id="quick-share-quick-view" class="quick-view-btn" aria-label="share-btn">
                <i class="icon-share"></i>
            </button>
        `;
    }
  }}
  ${({ canShowDownloadButtonInQuickPreview }) => {
    if (canShowDownloadButtonInQuickPreview) {
      return `
            <button data-tooltip="Download" id="download-quick-view" class="quick-view-btn" aria-label="download-btn">
                <i class="icon-download"></i>
            </button>`;
    }
  }}
  ${({ mediaType }) => {
    if (mediaType === mediaTypes.IMAGE) {
      return `
          <button data-tooltip="zoomIn" id="zoomIn" class="quick-view-btn" aria-label="zoom-btn">
            <i class="icon-plus"></i>
          </button>
          <button data-tooltip="zoomOut" id="zoomOut" class="quick-view-btn" aria-label="minus-btn">
            <i class="icon-minus"></i>
          </button>`;
    }
  }}
  <button data-tooltip="previousSlide" id="left-angle" class="quick-view-btn" aria-label="forward-btn">
    <i class="icon-chevron-left"></i>
  </button>
  <button data-tooltip="nextSlide" id="right-angle" class="quick-view-btn" aria-label="backward-btn">
    <i class="icon-chevron-right"></i>
  </button>
  ${({ mediaType, canHideRotateIconsInPreview }) => {
    if (mediaType === mediaTypes.IMAGE && !canHideRotateIconsInPreview) {
      return `
          <button data-tooltip="rotateImageLeft" id="leftRotate" class="quick-view-btn" aria-label="undo-btn">
            <i class="icon-undo"></i>
          </button>
          <button data-tooltip="rotateImageRight" id="rightRotate" class="quick-view-btn" aria-label="rotate-btn">
            <i class="icon-repeat"></i>
          </button>`;
    }
  }}
  ${({ canShowAddToBasketButtonInQuickPreview }) => {
    if (canShowAddToBasketButtonInQuickPreview) {
      return `
            <button data-tooltip="Add To Basket" id="add-to-basket-quick-view" class="quick-view-btn" aria-label="add-to-basket-btn">
                <i class="icon-plus-sign"></i>
            </button>`;
    }
  }}
  ${({ canShowKeywordButtonInQuickPreview }) => {
    if (canShowKeywordButtonInQuickPreview) {
      return `
            <button data-tooltip="Edit Keywords" id="edit-keywords-quick-view" class="quick-view-btn" aria-label="edit-keywords-btn">
                <i class="icon-tags"></i>
            </button>`;
    }
  }}
`;

export default { slideShowTemplate, controlBarTemplate };
